export const PLAY_AUDIO = "PLAY_AUDIO";
export const PAUSE_AUDIO = "PAUSE_AUDIO";
export const SET_AUDIO = "SET_AUDIO";
export const RESET_AUDIO = "RESET_AUDIO";
export const SET_PROGRESS = "SET_PROGRESS";

interface ActionTypes {
  PLAY_AUDIO: any;
  PAUSE_AUDIO: any;
  SET_AUDIO: any;
  RESET_AUDIO: any;
  SET_PROGRESS: any;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function playAudio(): AudioPlayerActionsTypes {
  return {
    type: PLAY_AUDIO,
    payload: "",
  };
}

export function pauseAudio(): AudioPlayerActionsTypes {
  return {
    type: PAUSE_AUDIO,
    payload: "",
  };
}

export function setAudio(audio: object): AudioPlayerActionsTypes {
  return {
    type: SET_AUDIO,
    payload: audio,
  };
}
export function resetAudio(): AudioPlayerActionsTypes {
  return {
    type: RESET_AUDIO,
    payload: "",
  };
}

export function setProgress(progress: number): AudioPlayerActionsTypes {
  return {
    type: SET_PROGRESS,
    payload: progress,
  };
}

export type AudioPlayerActionsTypes = MessageAction;
